import { render, staticRenderFns } from "./ModalVideos.vue?vue&type=template&id=22df142d"
import script from "./ModalVideos.vue?vue&type=script&lang=js"
export * from "./ModalVideos.vue?vue&type=script&lang=js"
import style0 from "./ModalVideos.vue?vue&type=style&index=0&id=22df142d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports